import { useEffect, useRef } from 'react';
import { preloadArmor } from './render/Armor';
import { Canvas } from '@react-three/fiber';
import { Scene } from './render/Scene';
import { SpectatorScene } from './render/SpectatorScene';
import { SpectatorHud } from './ui/SpectatorHud';
import { OnlineLobby, OpponentAway } from './ui/Online';
import { useGame } from './game/store';
import { Hud } from './ui/Hud';
import { Controls, useGestures } from './ui/Controls';
import { Intro, Results } from './ui/Screens';
import { SignInSheet } from './ui/Account';

export function App() {
  const phase = useGame((s) => s.phase);
  const mode = useGame((s) => s.mode);
  const stage = useRef<HTMLDivElement>(null);
  useGestures(stage);
  // Fetch the suits once the title screen is up, so a rival's armor is ready by the first sighting.
  useEffect(() => {
    const t = setTimeout(() => {
      try {
        preloadArmor();
      } catch {
        /* the placeholder stands in */
      }
    }, 1500);
    return () => clearTimeout(t);
  }, []);
  return (
    <>
      <div className="stage" ref={stage} aria-hidden="true">
        {phase !== 'intro' && (
          <Canvas camera={{ fov: 78, near: 0.05, far: 60 }} dpr={[1, 2]} gl={{ antialias: true }}>
            {mode === 'watch' ? <SpectatorScene /> : <Scene />}
          </Canvas>
        )}
      </div>
      {phase !== 'intro' && mode !== 'watch' && (
        <>
          <Hud />
          <Controls />
          <OpponentAway />
        </>
      )}
      {phase !== 'intro' && mode === 'watch' && <SpectatorHud />}
      {phase === 'intro' && <Intro />}
      {phase === 'over' && <Results />}
      <OnlineLobby />
      <SignInSheet />
    </>
  );
}
